import React from 'react'
import { InputField, Select } from '@enamelai/design-system'
import { APIProvider } from '@vis.gl/react-google-maps'
import AddressField from '@components/common/AddressField/AddressField.component'
import { US_STATE_OPTIONS } from '@constants/Providers'
import { getEnv } from '@utils/env'

const GOOGLE_MAPS_API_KEY = getEnv('REACT_APP_GOOGLE_MAPS_API_KEY', '')

export type CarrierAddress = {
  address: string
  city: string
  state: string
  zip: string
}

type AddressFieldsProps = {
  value: CarrierAddress
  onChange: (field: keyof CarrierAddress, value: string) => void
}

const AddressFields: React.FC<AddressFieldsProps> = ({ value, onChange }) => (
  <>
    <APIProvider apiKey={GOOGLE_MAPS_API_KEY} libraries={['places']}>
      <AddressField
        ds
        className="carriers-address-field"
        listboxId="carriers-address-suggestions"
        label="Address"
        placeholder="Enter an address"
        value={value.address}
        countries={['US']}
        onChange={(next) => onChange('address', next)}
        onSelect={(_place, parsed) => {
          onChange('address', parsed.formattedAddress2 ?? '')
          onChange('city', parsed.city ?? '')
          onChange('state', parsed.state ?? '')
          onChange('zip', parsed.postalCode ?? '')
        }}
      />
    </APIProvider>
    <div className="carriers-form-row carriers-form-row--city-state-zip">
      <InputField
        fullWidth
        variant="text"
        label="City"
        placeholder="Enter city"
        value={value.city}
        onChange={(e) => onChange('city', e.target.value)}
      />
      <Select
        label="State"
        placeholder="Select state"
        options={US_STATE_OPTIONS}
        value={value.state}
        onChange={(next) => onChange('state', String(next))}
      />
      <InputField
        fullWidth
        variant="text"
        label="ZIP"
        placeholder="Enter ZIP"
        value={value.zip}
        onChange={(e) => onChange('zip', e.target.value)}
      />
    </div>
  </>
)

export default AddressFields
